<div class="d-flex menu-bar">
  @for (tab of tabsList; track i;let i=$index) {
  <div [ngClass]="tab.active?'menu-active':'menu-inactive'" (click)="tabClickEvent(tab,i)">
    @if(tab.text.length>12){
    <ejs-tooltip [content]="tab.text">
      <div class="tabs">
        <span class="dot"
          [ngClass]="[tab && tab?.url.startsWith('promotion') ? 'promotion-circle' : '',  tab && tab?.url.startsWith('proposal') ? 'proposal-circle' : '']">
        </span>
        <span class="tabName">{{tab.text|longText:12}}</span>
        @if(tab.text!=='Manage Invoice'&& tab.text!=='Summary'&& tab.text!=='Dashboard'){
        <span (click)="closeTab(i)" class="closeBtn">x</span>
        }@else if(tab.text==='Manage Invoice'){
        @if(!ocadoAuthService.roleIdList.includes('PROMO_FINANCE')){
        <span (click)="closeTab(i)" class="closeBtn">x</span>
        }
        }
      </div>
    </ejs-tooltip>
    } @else {
    <!-- <ng-template #normalGroup> -->
    <div class="tabs">
      <span class="dot"
        [ngClass]="[tab && tab?.url.startsWith('promotion') ? 'promotion-circle' : '',  tab && tab?.url.startsWith('proposal') ? 'proposal-circle' : '']"></span>
      <span class="tabName">{{tab.text}}</span>
      @if(tab.text!=='Manage Invoice'&& tab.text!=='Summary'&& tab.text!=='Dashboard'){
      <span (click)="closeTab(i)" class="closeBtn">x</span>
      }@else if(tab.text==='Manage Invoice'){
      @if(!ocadoAuthService.roleIdList.includes('PROMO_FINANCE')){
      <span (click)="closeTab(i)" class="closeBtn">x</span>
      }
      }
    </div>
    <!-- </ng-template> -->
    }
  </div>
  }
  <div class="plus-icon" (click)="clickPlus($event)">+</div>
  <div class="plus-tab">
    <ejs-dialog #menuBar cssClass="menu-wrapper e-template-menu" [ngStyle]="{left:dialogLeft+'px'}" #menus
      [visible]="plusDialog">
      <ng-template #content>
        <div (click)="preventDialogClose($event)" class="d-flex flex-row">
          @if (menuItems.length) {
          <div class="e-card">
            <div class="e-card-header">
              <div class="e-card-header-caption">
                <div class="e-card-header-title d-inline-block" i18n>MY VIEWS</div>
              </div>
            </div>
            <div class="d-flex flex-column my-2 mx-1 e-card-content view-container">
              @for (menu of menuItems; track $index) {
              <div class='item-wrapper'>
                <span class="item" [id]="menu.search_id" (click)="clickView(menu)">{{menu.search_name}}</span>
                @if(menu.is_default !== 'Y'){
                <span class="default-btn" role="button" (click)="onClickDefaultBtn(menu)" i18n>Default</span>
                }
                @if(menu.is_default ==='Y'){
                <span class="default-yellow-btn" i18n>Default</span>
                }
              </div>
              }
            </div>
          </div>
          }
          @if (menuList.length) {
          <div class="e-card">
            <div class="e-card-header">
              <div class="e-card-header-caption">
                <div class="e-card-header-title d-inline-block" i18n>MENU</div>
                <div class="d-flex flex-column my-2 mx-1 e-card-content view-container">
                  @for (menu of menuList; track $index) {
                  <div class='item-wrapper'>
                    <span class="item" (click)="clickMenu(menu)">{{menu.text}}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
          @if (reportsList.length) {
          <div class="e-card">
            <div class="e-card-header">
              <div class="e-card-header-caption">
                <div class="e-card-header-title d-inline-block" i18n>Reports</div>
                <div class="d-flex flex-column my-2 mx-1 e-card-content view-container">
                  @for (menu of reportsList; track $index) {
                  <div class='item-wrapper'>
                    <span class="item" (click)="clickMenu(menu)">{{menu.text}}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </ng-template>
    </ejs-dialog>
  </div>

</div>
<router-outlet></router-outlet>
<ejs-dialog cssClass="warningModal" #warningBoxDialog isModal="true" id='dialog' [visible]="warningDialog"
  height='205px' width='435px'>
  <ng-template #header>
    <div class="d-flex justify-content-end"><span (click)="resumeEdit()" type="button"
        class="e-icons icon-variant30"></span></div>
  </ng-template>
  <ng-template #content>
    <div>
      <div class="d-flex justify-content-center unsaved" i18n>Unsaved Changes</div>
      <div class="d-flex justify-content-center content-dialog top-pad" i18n>Are you sure you want to discard?</div>
      <div class="d-flex justify-content-center content-dialog" i18n>Edits made will be lost.</div>
    </div>
    <div class="btns">
      <button ejs-button cssClass="apply-btn" (click)="resumeEdit()" type="button" i18n>Keep editing</button>
      <button ejs-button cssClass="e-flat" (click)="discard()" type="button" i18n>Discard Changes</button>
    </div>
  </ng-template>
</ejs-dialog>

@if(tabLimitReached){
<ocado-common-dialog i18n-title title="Tab Limit" [message1]="promotionConstants.Dialog_Messages.exceed_message"
  [message2]='tabScreenLimitReachedMsg' [actionBtn]="promotionConstants.Dialog_Messages.ok_button" cancelBtn=""
  (cancelBtnEvent)="btnTrigger()" (actionBtnEvent)="btnTrigger()"></ocado-common-dialog>
}